export default {
  buttons: {
    change_plan: 'Cambia piano',
  },
  toasts: {
    failed_to_load_data: 'Caricamento dati non riuscito',
    failed_to_save_changes: 'Salvataggio modifiche non riuscito',
  },
};
